
export default [
  {
    "ref": "alex-thompson",
    "name": "Alex Thompson",
    "avatar": "https://randomuser.me/api/portraits/men/75.jpg",
    "content": "",
    "_meta": {
      "filePath": "authors/alex-thompson.mdx",
      "fileName": "alex-thompson.mdx",
      "directory": "authors",
      "extension": "mdx",
      "path": "authors/alex-thompson"
    }
  },
  {
    "ref": "david-kim",
    "name": "David Kim",
    "avatar": "https://randomuser.me/api/portraits/men/22.jpg",
    "content": "",
    "_meta": {
      "filePath": "authors/david-kim.mdx",
      "fileName": "david-kim.mdx",
      "directory": "authors",
      "extension": "mdx",
      "path": "authors/david-kim"
    }
  },
  {
    "ref": "emma-wilson",
    "name": "Emma Wilson",
    "avatar": "https://randomuser.me/api/portraits/women/68.jpg",
    "content": "",
    "_meta": {
      "filePath": "authors/emma-wilson.mdx",
      "fileName": "emma-wilson.mdx",
      "directory": "authors",
      "extension": "mdx",
      "path": "authors/emma-wilson"
    }
  },
  {
    "ref": "jane-doe",
    "name": "Jane Doe",
    "avatar": "https://randomuser.me/api/portraits/women/11.jpg",
    "content": "",
    "_meta": {
      "filePath": "authors/jane-doe.mdx",
      "fileName": "jane-doe.mdx",
      "directory": "authors",
      "extension": "mdx",
      "path": "authors/jane-doe"
    }
  },
  {
    "ref": "jon-doe",
    "name": "Jon Doe",
    "avatar": "https://randomuser.me/api/portraits/men/81.jpg",
    "content": "",
    "_meta": {
      "filePath": "authors/jon-doe.mdx",
      "fileName": "jon-doe.mdx",
      "directory": "authors",
      "extension": "mdx",
      "path": "authors/jon-doe"
    }
  },
  {
    "ref": "michael-rodriguez",
    "name": "Michael Rodriguez",
    "avatar": "https://randomuser.me/api/portraits/men/32.jpg",
    "content": "",
    "_meta": {
      "filePath": "authors/michael-rodriguez.mdx",
      "fileName": "michael-rodriguez.mdx",
      "directory": "authors",
      "extension": "mdx",
      "path": "authors/michael-rodriguez"
    }
  },
  {
    "ref": "naresh-kumar",
    "name": "Naresh Kumar",
    "avatar": "/assets/naresh-kumar.jpg",
    "content": "",
    "_meta": {
      "filePath": "authors/naresh-kumar.mdx",
      "fileName": "naresh-kumar.mdx",
      "directory": "authors",
      "extension": "mdx",
      "path": "authors/naresh-kumar"
    }
  },
  {
    "ref": "priya-patel",
    "name": "Priya Patel",
    "avatar": "https://randomuser.me/api/portraits/women/33.jpg",
    "content": "",
    "_meta": {
      "filePath": "authors/priya-patel.mdx",
      "fileName": "priya-patel.mdx",
      "directory": "authors",
      "extension": "mdx",
      "path": "authors/priya-patel"
    }
  },
  {
    "ref": "sarah-chen",
    "name": "Sarah Chen",
    "avatar": "https://randomuser.me/api/portraits/women/44.jpg",
    "content": "",
    "_meta": {
      "filePath": "authors/sarah-chen.mdx",
      "fileName": "sarah-chen.mdx",
      "directory": "authors",
      "extension": "mdx",
      "path": "authors/sarah-chen"
    }
  }
]